import { createAppConfigFromEnv } from '@elva/platform';

// Digital Marketing has no dedicated client_id among the six seeded apps; uses onlinebooking until registered.
export const digitalMarketingPlatformConfig = createAppConfigFromEnv(import.meta.env, {
  appName: 'Elva Digital Marketing',
  tokenKey: 'elva_auth_token',
  loginCallbackPath: '/loginok',
  publicPathPrefix: '/public',
});
